import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, View, TouchableOpacity } from 'react-native';
import * as RootNavigation from '../../../root.navigation.js';

const width = Dimensions.get('window').width;


const PlusIcon = (props) => (
  <Icon {...props} name='plus-square-outline' />
);
const ClockIcon = (props) => (
  <Icon {...props} name='clock-outline' fill='#134A93' style={[props.style, {width:24,height:24, marginHorizontal:8 }]}/>
);
const CalendarIcon = (props) => (
  <Icon {...props} name='calendar-outline' fill='#134A93' style={[props.style, {width:24,height:24, marginHorizontal:8 }]}/>
);
export const Sharayet = () => {

  return (
      <Layout style={styles.container} level='3' >
      <SafeAreaView>
        <View style={{flex:1,justifyContent:'space-between'}}>
        <ScrollView>
        <Text category='h5' status='primary' style={{marginTop:20, textAlign:'center'}}>شرایط و مقررات</Text>

          <View style={{borderRadius:10, marginTop:20, alignItems:'flex-start', width:width-50, marginHorizontal:25}}>


          <Text style={{marginTop:5}} category='h6' status='primary'>
           تکنسین محترم تمام آنچه در مورد خدمات پس از فروش باید بدانید :
          </Text>
          <Text style={{marginTop:5}} status='primary'>
•	گارانتی محصولات صوتی/ تصویری
          </Text>
          <Text category='c1'>
محصولات صوتی 48 ماه گارانتی تعمیر دارد (4 سال) ( شامل خدمات درب محل نمیباشد )
          </Text>
          <Text category='c1'>
محصولات تصویری شامل 48 ماه گارانتی (4 سال) که یکسال آن شامل گارانتی تعویض برای مشتری می باشد .
          </Text>
          <Text category='c1'>
محصول پنل کدینگ سری  :  Gold Silverبه علت سفارشی بودن این محصول شامل گارانتی تعویض نمی باشد و تعمیرآن فقط توسط کارخانه انجام می شود
          </Text>
          <Text category='c1'>
محصولات درب باز کن های کنترلی شامل 24 ماه گارانتی میباشد .
          </Text>

          <Text style={{marginTop:15}} status='primary'>
•	خدمات
          </Text>
          <Text category='c1'>
مشتری جهت نصب یا خرابی دستگاه خود با شرکت تماس میگیرد و  ثبت آدرس میکند .
          </Text>

          <Text style={{marginTop:15}} status='primary'>
•	نحوه اطلاع رسانی به تکنسین فنی  :
          </Text>
          <Text category='c1'>
پیامک تخصیص یافتن کار به تکنسین ارسال میشود و بعد از مراجعه تکنسین به اپلیکیشن خدمات میتواند ادرس و شماره تماس مشتری را مشاهده کند
          </Text>
          <Text category='c1'>
اولین اقدام تکنسین  جهت هماهنگی و مراجعه با مشتری تماس میگیرد در صورت هماهنگی با مشتری گزینه پذیرش مشتری را فعال میکند
          </Text>
          <Text category='c1'>
در صورت پاسخ گو نبودن مشتری گزینه مورد نظر را با ذکر توضیحات ثبت کنید
          </Text>
          <Text category='c1'>
در صورت کنسل شدن کار توسط مشتری گزینه مورد نظر را با ذکر توضیحات ثبت کنید
          </Text>

          <Text category='c1'>
          در صورت راهنمایی مشتری توسط تماس تلفنی با ذکر توضیحات ثبت کنید
          </Text>
          <Text category='c1'>
          (بعد از ثبت هر کدام از مواد بالا  همکاران واحد خدمات با مشنری تماس میگیرند)
          </Text>
          <Text category='c1'>
          تکنسین های فنی توجه داشته باشند آدرس ها  نهایتا ظرف مدت 24 الی 48 ساعت باید انجام بشود
          </Text>

          <Text category='c1'>
          بعد از اتمام کار اطلاعات دستگاه در اپلیکیشن وارد شود

          </Text>
          <Text category='c1'>
          محصول : درب باز کن صوتی و تصویری ـ درب بازکن کنترلی
          </Text>

          <Text category='c1'>
          مدل : مدل محصولی که جهت نصب و خرابی مراجعه کردید وارد شود ( اگر دستگاه ها بیش از یک عدد هست در توضحات ذکر شود)
          </Text>

          <Text category='c1'>
          شماره سریال : با استفاده از بارکد خوان یا وارد کردن دستی بارکد محصول را ثبت کنید ( اگر نصب هست بر روی کارتن محصول موجود هست )
          </Text>
          <Text category='c1'>
          تاریخ تولید محصول : تاریخ تولید محصول را وارد نمایید ( اگر نصب هست بر روی کارتن محصول موجود هست )
          </Text>
          <Text category='c1'>
          گزینه دارای گارانتی در صورت داشتن گارانتی برای محصول فعال شود
          </Text>

          <Text category='c1'>
          اگر مواردی دیگر مانند ایاب ذهاب دارد میتوانید از طریق لیست اقدامات وارد نمایید
          </Text>
          <Text category='c1'>
          توضیحات لازم جهت اقدامات اجام شده برای شرکت و مشتری و مواردی که لازم هست در فاکتور مشتری ثبت شود از این طریق یاداشت شود
          </Text>
          <Text category='c1'>
          اگر کاری  بیشتر از 48 ساعت زمان میبرد ( پروژه ) به شرکت حتماً اطلاع دهید و در صورت نداشتن زمان برای انجام کار شرکت را در جریان قرار دهید
          </Text>
          <Text style={{marginTop:15}} status='primary'>
•	فاکتورها
          </Text>
          <Text category='c1'>
          تمام فاکتور ها ذخیره میشود و به صورت فایل pdf قابل دانلود میباشد
          </Text>
          <Text category='c1'>
          تمام موارد ثبت شده برای خدمات پس از فروش شرکت میباشد و خدماتی غیر از خدمات شرکت با مسئولست خود تکنسین در فاکتور شخصی خودتان یاداشت شود
          </Text>
          <Text category='c1'>
          هزینه فاکتور های گارانتی هر 15 روز یکبار با تکنسین تسویه میگردد و تمام فاکتور های پرداخت شده و پرداخت نشده قابل مشاهده میباشد
          </Text>
          <Text style={{marginTop:15}} status='primary'>
          تکنسین فنی
          </Text>
          <Text category='c1'>
          در صورت نیاز به مرخصی حتماً اطلاع دهید تا ما فرصت پیداکردن و هماهنگی با نفر جایگزین را داشته باشیم .
          </Text>
          <Text category='c1'>
          اگر کار نصب هست قبل از حضور در محل  ، هزینه نصب به مشتری اعلام کنید و سپس کار را انجام دهید .
          </Text>
          <Text category='c1'>
          مشتری که با آن بابت هزینه ها صحبت کردید حتماً در محل و زمان نصب حضور داشته باشد .
          </Text>
          <Text category='c1'>
          اگر در محل کار مجبور به انجام کارهای متفرقه از جمله : سیم کشی - جوشکاری - کنده کاری و برش سنگ - عیب یابی  شدید قبل از انجام کار در مورد هزینه با مشتری به توافق برسید
          </Text>
          <Text style={{marginTop:15}} status='primary'>
          گارانتی
          </Text>
          <Text category='c1'>
          1) گارانتی محصولات  : تمام مراحل انجام کار به صورت رایگان برای مشتری می باشد و شما نباید هزینه ای دریافت کنید ،
          </Text>
          <Text category='c1'>
          2)غیرگارانتی : اگر دستگاه ها غیرگارانتی است و   مشکل دقیق را می دانید به مشتری اعلام هزینه کنید ، در غیر این صورت بهتراست اول در محل مشتری حضور پیدا کنید و بعد اعلام هزینه شود .
          </Text>

          <Text category='c1'>
          اگر برای تعویض برد در محل مشتری مراجعه کردید اول هزینه  برد را  اعلام کنید بعد تعویض کنید . محدوده مجاز برای  قیمت دهی برد به مشتری توسط تکنسین 20درصد می باشد .
          </Text>
          <Text category='c1'>
          عیب یابی سیم : عیب یابی سیم ، قطعی یا اتصالی هزینه توافقی است و باید در ابتدا توضیحات لازم به مشتری داده شود که رفع عیب سیم جز خدمات شرکت نمی باشد و هزینه ان توافقی می باشد و بعد هزینه به مشتری اعلام شود سپس کار را انجام دهید .
          </Text>
          <Text style={{marginTop:15}} status='primary'>
          •	محصولاتی که غیرگارانتی محسوب می شوند :
          </Text>
          <Text category='c1'>
          1) گذشتن تاریخ گارانتی / آسیب دیدن برد بر اثر نوسانات برق و اتصالی / آسیب دیدگی و شکستگی محصول
          </Text>
          <Text category='c1'>
          2 ) آب خوردگی بردها ( زنگ زدگی ) نصب اشتباه اتصالی سیم / در معرض شعله و حرارت بود.
          </Text>

          <Text style={{marginTop:15}} status='primary'>
•	دستورالعمل گارانتی تعویض برای مشتری ها و تکنسین فنی
          </Text>
          <Text category='c1'>
در هنگام مراجعه تکنسین درب منزل مشتری جهت خدمات پس از فروش اگر دستگاه مشتری شامل گارانتی تعویض می شد ، در ابتدا مشتری را مجاب کند که برد دستگاه را تعویض کنند در صورت رضایت ندادن مشتری به مشتری اعلام شود : با مراجعه به نماینده فروش و یا با ارسال محصول به کارخانه دستگاه خود را تعویض کنند.
          </Text>
          <Text category='c1'>
          تذکر : (حتماً به تاریخ تولید و مهلت تعویض دقت شود )
          </Text>
          <Text category='c1'>
          ماده 1 :
          </Text>
          <Text category='c1'>
          تکنسین وظیفه دارد برد دستگاه را تعویض کند و جهت تعویض دستگاه هیچ تعهدی ندارد .
          </Text>
          <Text category='c1'>
          ماده 2 :
          </Text>
          <Text category='c1'>
          این دستورالعمل برای تکنسین های سراسر کشور قابل اجرا می باشد .
          </Text>
          <Text category='c1'>
          ماده 3 :
          </Text>
          <Text category='c1'>
          در صورت تعویض دستگاه توسط مشتری و درخواست تکنسین برای نصب مجدد هزینه ایاب و ذهاب به عهده مشتری می باشد .
          </Text>
          <Text category='c1'>
          ماده 4 :
          </Text>
          <Text category='c1'>
          هزینه ارسال دستگاه برای تعویض به کارخانه یک طرف با مشتری و یک طرف با کارخانه است .
          </Text>
          <Text category='c1'>
ماده 5 :
          </Text>
          <Text category='c1'>
          در صورت مراجعه تکنسین به منزل مشتری و تشخیص خرابی دستگاه مشتری رضایت به تعویض برد نمیدهد.هزینه بار اول مراجعه تکنسین با شرکت میباشد .
          </Text>
          <Text category='c1'>
          ماده 6 :
          </Text>
          <Text category='c1'>
          در صورت مراجعه تکنسین به منزل مشتری و تشخیص سالم بودن دستگاه هزینه ایاب ذهاب با شرکت و هزینه تست دستگاه با مشتری میباشد . هزینه تست(000/ 40 )تومان
          </Text>


        </View>
        </ScrollView>
        <Button onPress={()=>{RootNavigation.navigate('profile')}} appearance='outline' style={{borderRadius:10, margin:20}}>بازگشت</Button>
        </View>
      </SafeAreaView>
      </Layout>

  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'flex-start',

  },
});
